import React from "react";
import "./styles.css";

export default class AffiliateModal extends React.Component {
  state = {
    toEdit: "aid",
    toEditValue: "",
  };

  componentDidUpdate(prevProps) {
    if (prevProps.modalOpen === false && this.props.modalOpen === true) {
      this.setState({
        toEdit: "aid",
        toEditValue: this.props.affiliateInfo.affiliate.aid,
      });
    }
  }

  handleSelectChange = (e) => {
    const selectValue = e.target.value;
    const {
      aid,
      balance,
      totalearned,
      conversions,
      clicks,
    } = this.props.affiliateInfo.affiliate;
    switch (selectValue) {
      case "aid":
        this.setState({ toEdit: "aid", toEditValue: aid });
        break;
      case "balance":
        this.setState({ toEdit: "balance", toEditValue: balance });
        break;
      case "sales":
        this.setState({ toEdit: "sales", toEditValue: conversions });
        break;
      case "totalearned":
        this.setState({ toEdit: "totalearned", toEditValue: totalearned });
        break;
      case "clicks":
        this.setState({ toEdit: "clicks", toEditValue: clicks });
        break;
      default:
        break;
    }
  };

  onConfirm = () => {
    const { idToken, affiliateInfo } = this.props;
    const { toEdit, toEditValue } = this.state;
    this.props.closeModal();
    fetch(
      `https://us-central1-project-1029735015520686877.cloudfunctions.net/editAffiliateInfo?idToken=${idToken}&uid=${affiliateInfo.uid}&toEdit=${toEdit}&toEditValue=${toEditValue}`,
      {
        mode: "no-cors",
      }
    ).then(() => {
      // this.props.closeModal();
      this.props.refresh();
    });
  };

  render() {
    const { modalOpen, closeModal, affiliateInfo } = this.props;
    return (
      <div className={modalOpen ? "affmodalwrapper open" : "affmodalwrapper"}>
        <div className="affmodal">
          {modalOpen ? (
            <div className="affmodalcontent">
              <h2>Edit Affiliate Info</h2>
              <p>Name: {affiliateInfo.name}</p>
              <p>Email: {affiliateInfo.email}</p>
              <p>UID: {affiliateInfo.uid}</p>
              <div className="edit">
                <select
                  onChange={this.handleSelectChange}
                  value={this.state.toEdit}
                >
                  <option value="aid">AID</option>
                  <option value="balance">Balance</option>
                  <option value="totalearned">Total Earned</option>
                  <option value="sales">Sales</option>
                  <option value="clicks">Clicks</option>
                </select>
                <input
                  onChange={(e) =>
                    this.setState({ toEditValue: e.target.value })
                  }
                  value={this.state.toEditValue}
                />
              </div>
            </div>
          ) : null}
          <div className="buttons">
            <button className="nobtn" onClick={closeModal}>
              Cancel
            </button>
            <button className="yesbtn" onClick={this.onConfirm}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/pages/admin/sections/users/components/affiliateModal/index.js
 **/